export enum RightSidePanelType {
    LiveMode = 'Live Mode',
    QuickMode = 'Quick Mode',
    AdvancedMode = "Advanced Mode",
  }